/*
	NMC Nav

	What does this do?
	=================
	This is plain js that works in tandem with nav-primary.twig in our default setup. For
	convenience and simplicity, the classnames are hardcoded in both places.

	This js will handle the mobile hamburger toggle of the menu and it also handles the 
	accessibility functions of the main dropdowns if they exist.

	It is kept as simple as possible.

	What does it not do?
	=================
	It does not toggle visibility by itself. That has to happen in CSS. For the dropdowns,
	nothing changes on the target dropdown itself since we're using aria-expanded. But,
	since we know the dropdown will immediately follow the button toggle, we can do this:

	.nmcnav_dropdown { display: none; }
	[aria-expanded="true"]+.nmcnav_dropdown { display: block; }

	A couple of notes:
	=================
	* Visibility toggling MUST include 'display: none'. This is required for accessibility
	  purposes. Use 'animate' instead of transitions if animation is desired.
	* There is a 'navopen' class added to the html element for the mobile toggle
	* If anything unique and structrual happens in the nav for a particular site, test
	  carefully.

*/
(function(){

	var $html = document.querySelector('html');
	var $toggle = document.getElementById('nmcnav_mobile-toggle');
	var $wrap = document.getElementById('nmcnav_wrap');

	// only initialize if toggle and wrap exist
	if ($toggle && $wrap) {

		var $ddButtons = document.querySelectorAll('[aria-controls|="nmcnav_dropdown"]');
		var $ddCloseButtons = document.querySelectorAll('.nmcnav_close-dropdown button');

		var $topLevelItems = document.querySelectorAll('.nmcnav_clickable, .nmcnav_secondary a');
		

		var _isExpanded = function($button) { return $button.getAttribute('aria-expanded') == 'true' };
		var _expand = function($button) { $button.setAttribute('aria-expanded','true'); };
		var _contract = function($button) { $button.setAttribute('aria-expanded','false'); };

		var handleHTMLClass = function() {
			if(_isExpanded($toggle)) {
				$html.classList.add('navopen');
			} else {
				$html.classList.remove('navopen');
			}
		};
		var getTarget = function($button) {
			return document.getElementById($button.getAttribute('aria-controls'));
		};
		var focusOnTarget = function($button) {
			var $target = getTarget($button);
			$target.focus();
		}

		var toggleButtonTarget = function($button) {
			if(_isExpanded($button)) {
				closeButtonTarget($button);
			} else {
				closeAllDropdowns(); // had to include this here so other dropdowns close correctly in safari.
				openButtonTarget($button);
			}
		};
		var openButtonTarget = function($button) {
			_expand($button);
			handleHTMLClass();
			focusOnTarget($button);
		};
		var closeButtonTarget = function($button) {
			_contract($button);
			closeAllDropdowns();
			handleHTMLClass();
		};
		var closeAllDropdowns = function() {
			$ddButtons.forEach(function($button) {
				_contract($button);
			});
		};
		var closeEverything = function(e) {
			closeButtonTarget($toggle);
		};

		// Attach behaviors to dropdown buttons
		$ddButtons.forEach(function($button){
			$button.addEventListener('click',function() { toggleButtonTarget($button); });
		});
		// Attach behavior to mobile toggle:
		$toggle.addEventListener('click',function() { toggleButtonTarget($toggle); });

		// Close dropdowns when moving between dropdowns
		$topLevelItems.forEach(function($link){
			$link.addEventListener('focus',function(e){
				if(!_isExpanded($link)) {
					closeAllDropdowns();
				}
			});
		});

		// Close dropdown from close buttons
		$ddCloseButtons.forEach(function($button) {
			$button.addEventListener('click',function(e){
				e.stopPropagation();
				var $parentButton = $button.closest('.nmcnav_li').querySelector('.nmcnav_button');
				//$parentButton.click();
				//$button.closest('.nmcnav_li').focus();
				//$parentButton.focus();
				closeButtonTarget($parentButton);
			});
		});

		// Close dropdowns on esc or clicking the body of the page
		document.addEventListener('keyup',function(e){
			if(e.key == 'Escape') closeAllDropdowns();
		});
		
		document.querySelector('#main').addEventListener('click',closeEverything);
		document.querySelector('.footer').addEventListener('click',closeEverything);

		/* When focus leaves the nav, close the nav */
		$wrap.addEventListener('focusout',function(e){
			if(e.relatedTarget && e.relatedTarget.nodeName != 'BUTTON') {
			// wait for focus to shift to next element so we can find it
				window.setTimeout(function(){
					var $active = document.activeElement;
					var foundNav = $active.closest('.nmcnav_wrap');
					if(!foundNav) closeEverything();
				},50);
			}
		});

	}
})();
